export var ECheckState;
(function (ECheckState) {
    /**
     * 正常状态
     */
    ECheckState[ECheckState["Normal"] = 0] = "Normal";
    /**
     * 审核状态
     */
    ECheckState[ECheckState["InCheck"] = 1] = "InCheck";
    /**
     * 不考虑游戏性的洗钱状态
     */
    ECheckState[ECheckState["NoGame"] = 2] = "NoGame";
})(ECheckState || (ECheckState = {}));
